(function () {
  'use strict';

  var trackedCards = new Set();

  function getSkuSuffix(colorName) {
    var key = String(colorName || '').toLowerCase().replace(/[\s-]/g, '');
    var map = {
      black: 'BK',
      beige: 'WT',
      white: 'WT',
      grey: 'GY',
      gray: 'GY',
      purple: 'PR',
      pearl: 'PR',
      pink: 'PK',
      orange: 'OR',
      silver: 'SR'
    };
    return map[key] || 'BK';
  }

  function readGa4Dataset(el) {
    if (!el) return null;

    return {
      item_id: el.getAttribute('data-ga4-item-id') || '',
      item_name: el.getAttribute('data-ga4-item-name') || '',
      index: Number(el.getAttribute('data-ga4-index') || 0),
      item_list_id: el.getAttribute('data-ga4-item-list-id') || 'be&lok',
      item_list_name: el.getAttribute('data-ga4-item-list-name') || 'be&lok',
      item_category: el.getAttribute('data-ga4-item-category') || '',
      item_category2: el.getAttribute('data-ga4-item-category2') || 'Standard',
      item_category3: (el.getAttribute('data-ga4-item-category3') || '').replace('Default Title', 'none'),
      item_variant: el.getAttribute('data-ga4-item-variant') || 'Truewireless',
      price: Number(el.getAttribute('data-ga4-price') || 0) / 100,
      quantity: Number(el.getAttribute('data-ga4-quantity') || 1),
      currency: el.getAttribute('data-ga4-currency') || 'AUD',
      discountCents: Number(el.getAttribute('data-ga4-discount') || 0)
    };
  }

  function getCardGa4Config(cardRoot) {
    if (!cardRoot) return null;

    var dataEl = cardRoot.querySelector('.opendots-series-product__ga4-data');
    var config = readGa4Dataset(dataEl);
    if (!config || !config.item_id) return null;

    var activeSwatch = cardRoot.querySelector('.opendots-series-product__swatch.is-active');
    if (!activeSwatch) return config;

    var color = (activeSwatch.getAttribute('aria-label') || '').trim();
    var productHandle = cardRoot.getAttribute('data-product-handle') || '';
    var updated = Object.assign({}, config);

    if (color) {
      updated.item_category3 = color.replace('Default Title', 'none');
    }

    var priceCents = Number(activeSwatch.getAttribute('data-price') || 0);
    if (priceCents > 0) {
      updated.price = priceCents / 100;
    }

    if (productHandle === 'opendots-2') {
      updated.item_category = 'E320';
      updated.item_id = 'E320' + getSkuSuffix(color);
      updated.item_name = 'OpenDots-2-' + color;
    } else if (productHandle === 'opendots-air') {
      updated.item_category = 'E210';
      updated.item_id = 'E210' + getSkuSuffix(color);
      updated.item_name = 'OpenDots-Air-' + color;
    }

    return updated;
  }

  function buildGa4Item(config, itemListNameOverride) {
    var item = {
      item_id: config.item_id,
      item_name: config.item_name,
      index: config.index,
      item_list_id: config.item_list_id,
      item_list_name: itemListNameOverride || config.item_list_name,
      item_category: config.item_category,
      item_category2: config.item_category2,
      item_category3: config.item_category3,
      item_variant: config.item_variant,
      item_brand: 'SHOKZ',
      price: config.price,
      quantity: config.quantity,
      currency: config.currency
    };

    if (config.discountCents > 0) {
      item.discount = config.discountCents / 100;
    }

    return item;
  }

  function isCardBottomVisible(entry) {
    var rect = entry.boundingClientRect;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom <= viewportHeight && rect.bottom > 0;
  }

  function pushOpendotsSeriesViewItemList(config) {
    if (!config || !config.item_id || typeof window.dataLayer === 'undefined') return;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'view_item_list',
      event_parameters: {
        currency: config.currency,
        item_list_id: config.item_list_id,
        item_list_name: config.item_list_name,
        items: [buildGa4Item(config)]
      }
    });
  }

  function pushOpendotsSeriesSelectItem(config, buttonName) {
    if (!config || !config.item_id || typeof window.dataLayer === 'undefined') return;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        item_list_id: config.item_list_id,
        item_list_name: config.item_list_name,
        currency: config.currency,
        button_name: buttonName,
        items: [buildGa4Item(config, 'Navigation _ ' + config.item_list_name)]
      }
    });
  }

  function getCardQuantity(cardRoot) {
    if (!cardRoot) return 1;

    var form = cardRoot.querySelector('.opendots-series-product__cart-form');
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    return Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10) || 1);
  }

  function pushOpendotsSeriesAddToCart(config, buttonName, quantity) {
    if (!config || !config.item_id || typeof window.dataLayer === 'undefined') return;

    quantity = quantity || config.quantity || 1;
    var item = buildGa4Item(config);
    item.quantity = quantity;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'add_to_cart',
      event_parameters: {
        button_name: buttonName,
        currency: config.currency,
        value: config.price * quantity,
        item_list_id: config.item_list_id,
        item_list_name: config.item_list_name,
        items: [item]
      }
    });
  }

  function handleCardImpression(entry, observer) {
    if (!isCardBottomVisible(entry)) return;

    var cardRoot = entry.target.closest('opendots-series-product-card');
    var cardKey = cardRoot ? cardRoot.dataset.blockId : entry.target.dataset.sectionId;
    if (!cardKey || trackedCards.has(cardKey)) {
      observer.unobserve(entry.target);
      return;
    }

    var config = getCardGa4Config(cardRoot);
    if (!config) {
      observer.unobserve(entry.target);
      return;
    }

    trackedCards.add(cardKey);
    pushOpendotsSeriesViewItemList(config);
    observer.unobserve(entry.target);
  }

  function initLearnMoreGa4() {
    document.addEventListener('click', function (event) {
      var learnBtn = event.target.closest('.opendots-series-product__btn--learn');
      if (!learnBtn) return;

      var cardRoot = learnBtn.closest('opendots-series-product-card');
      var config = getCardGa4Config(cardRoot);
      if (!config) return;

      var buttonName = (learnBtn.textContent || '').trim();
      pushOpendotsSeriesSelectItem(config, buttonName);
    });
  }

  function getAtcButtonName(cardRoot) {
    if (!cardRoot) return '';

    var buttonName = cardRoot.getAttribute('data-ga4-atc-button-name') || '';
    if (buttonName) return buttonName;

    var productHandle = cardRoot.getAttribute('data-product-handle') || '';
    if (productHandle === 'opendots-2') return 'be';
    if (productHandle === 'opendots-air') return 'lok';
    return '';
  }

  function pushOpendotsSeriesSelectContent(contentName, buttonName) {
    if (typeof window.dataLayer === 'undefined') return;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'item_list_atc',
        content_name: contentName || '',
        button_name: buttonName
      }
    });
  }

  function initCartGa4() {
    document.addEventListener('click', function (event) {
      var cartBtn = event.target.closest('.opendots-series-product__btn--cart');
      if (!cartBtn || cartBtn.disabled) return;

      var cardRoot = cartBtn.closest('opendots-series-product-card');
      var sectionRoot = cartBtn.closest('.opendots-series-product');
      if (!cardRoot || !sectionRoot) return;

      var contentName = sectionRoot.getAttribute('data-ga4-content-name') || '';
      var buttonName = getAtcButtonName(cardRoot);
      if (!buttonName) return;

      pushOpendotsSeriesSelectContent(contentName, buttonName);
    });
  }

  function getGiftModalOptionButtonName(optionEl, cardRoot) {
    var giftId = Number(optionEl.getAttribute('data-gift-id') || 0);
    if (!giftId || !cardRoot) return 'earring';

    var caseIds = [
      Number(cardRoot.getAttribute('data-gift-case-copy-id') || 0),
      Number(cardRoot.getAttribute('data-gift-case-id') || 0)
    ].filter(function (id) {
      return id > 0;
    });

    return caseIds.indexOf(giftId) !== -1 ? 'case' : 'earring';
  }

  function initGiftModalOptionGa4() {
    document.addEventListener('click', function (event) {
      var optionEl = event.target.closest('.opendots-series-product__gift-modal-option');
      if (!optionEl) return;

      var cardRoot = optionEl.closest('opendots-series-product-card');
      var sectionRoot = optionEl.closest('.opendots-series-product');
      if (!cardRoot || !sectionRoot) return;

      var contentName = sectionRoot.getAttribute('data-ga4-content-name') || '';
      var buttonName = getGiftModalOptionButtonName(optionEl, cardRoot);
      pushOpendotsSeriesSelectContent(contentName, buttonName);
    });
  }

  function initGiftModalConfirmGa4() {
    var lastConfirmGa4At = 0;
    var lastConfirmGa4CardKey = '';
    document.addEventListener('click', function (event) {
      var confirmBtn = event.target.closest('[data-gift-modal-confirm]');
      if (!confirmBtn || confirmBtn.disabled) return;

      var cardRoot = confirmBtn.closest('opendots-series-product-card');
      if (!cardRoot) return;
      var cardKey = cardRoot.getAttribute('data-block-id') || '';
      var now = Date.now();
      if (cardKey && lastConfirmGa4CardKey === cardKey && now - lastConfirmGa4At < 500) return;
      lastConfirmGa4CardKey = cardKey;
      lastConfirmGa4At = now;

      var config = getCardGa4Config(cardRoot);
      if (!config) return;

      var buttonName = (confirmBtn.textContent || '').trim();
      if (!buttonName) return;

      pushOpendotsSeriesAddToCart(config, buttonName, getCardQuantity(cardRoot));
    });
  }

  function initOpendotsSeriesProductGa4() {
    var cards = document.querySelectorAll(
      '.opendots-series-product__card-scale, .opendots-series-product__card-mb'
    );
    if (!cards.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        handleCardImpression(entry, observer);
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1]
    });

    cards.forEach(function (card) {
      if (card.querySelector('.opendots-series-product__ga4-data')) {
        observer.observe(card);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOpendotsSeriesProductGa4();
    initLearnMoreGa4();
    initCartGa4();
    initGiftModalOptionGa4();
    initGiftModalConfirmGa4();
  });
})();
